'use client';

import { createStore } from 'zustand';

import { AuthenticatedUser } from '@/types/auth-base.types';
import { tryToLoadAuthenticatedUser } from '@/services/auth/user.service';
import { getAuthTokens, removeAuthTokens } from '@/storage/auth-tokens.storage';

export type AuthStoreState = {
  authenticatedUser: AuthenticatedUser | undefined;
};

export type ComputedAuthStoreState = {
  computed: {
    isLoggedIn: boolean;
  };
};

export const authStore = createStore<AuthStoreState & ComputedAuthStoreState>((set, get) => {
  return {
    authenticatedUser: undefined,
    computed: {
      get isLoggedIn() {
        return !!get().authenticatedUser;
      },
    },
  };
});

export const setAuthenticatedUser = (user: AuthenticatedUser | undefined) => {
  authStore.setState({ authenticatedUser: user });
};

export async function logoutUser() {
  authStore.setState({ authenticatedUser: undefined });
  removeAuthTokens();
}

export async function resolveAuthenticatedUser(accessToken?: string) {
  const token = accessToken || getAuthTokens()?.access_token;
  if (!token) {
    return;
  }
  const user = await tryToLoadAuthenticatedUser(token);
  if (!user) {
    return;
  }
  setAuthenticatedUser(user);
}
